import $ from 'jquery';
import Menu from '../components/Menu';
import Cart from '../components/Cart';

export default class StaticCart {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.events = [];
    // Shipping calculator
    this.$shippingToggle = this.$el.find('[data-shipping-calculator-toggle]');
    this.$shippingFieldsInline = this.$el.find('.shipping-calculator-inline .shipping-calculator-fields');

    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.data.button_update_shipping_title,
      submitButtonDisabled: this.data.button_update_shipping_disabled_title,
      customerIsLoggedIn: this.data.customer_logged_in,
      moneyFormat: this.data.money_format,
    });

    this.events.push(this.$shippingToggle.on('click.cart', (event) => {
      event.preventDefault();
      this._toggleInlineShippingCalculator();
    }));

    // Menu system
    this.states = {
      default: {
        buttonsSelector: '[data-cart-menu-buttons-default]',
        buttons: [
          {
            selector: '[data-cart-menu-button-calculate-shipping]',
            callback: () => { this.menu.changeState(this.states.shippingCalculator); },
          },
        ],
      },
      shippingCalculator: {
        slideoutSelector: '[data-cart-menu-slideout]',
        buttonsSelector: '[data-cart-menu-buttons-shipping-calculator]',
        buttons: [
          {
            selector: '[data-cart-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-cancel-shipping]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-update-shipping]',
            // None needed, Shopify.Cart.ShippingCalculator takes care of this
            callback: () => {},
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
    };

    this.$cartMenuContainer = $('[data-cart-menu-container]', this.$el);
    this.menu = new Menu(this.$cartMenuContainer, this.states, this.states.default);
    Cart.addCart(section.el);
  }

  _toggleInlineShippingCalculator() {
    // Toggle form
    this.$shippingFieldsInline.toggle();

    // Toggle button text
    const text = this.$shippingToggle.data('toggle-text');
    this.$shippingToggle.data('toggle-text', this.$shippingToggle.text());
    this.$shippingToggle.text(text);
  }

  onSectionMessage(name, data) {
    if (name === 'header-minicart:open') {
      const transitionEnded = $.Deferred();
      data(transitionEnded);
      this.$cartMenuContainer.one('transitionend', () => transitionEnded.resolve());
      this.menu.minimizeMenu();
    }
    if (name === 'header-minicart:close') {
      this.menu.maximizeMenu();
    }
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.cart'));
  }
}
